import styled, {css} from "styled-components";
import {flexAdaptiveSizeItem} from "../../../../themes/architecture/css-helpers/flex";

export const IndicatorContainerBox = styled.div<{alignAppliedFiltersToCenter: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1.5rem;
    ${flexAdaptiveSizeItem}
    font-family: ${props => props.theme.font.family.regular};
    ${props => props.theme.font.presets.regular};
    ${({alignAppliedFiltersToCenter}) => alignAppliedFiltersToCenter ? css`align-self: flex-start` : ''};
    max-width: 100%;
`;
